import React from 'react';
export function Footer() {
  return <footer className="bg-black py-4 border-t border-gray-900 text-center px-4" data-id="element-73">
      <p className="text-gray-500 text-sm font-medium" data-id="element-74">
        © Mega Pack Ingreso a las Fuerzas — Todos los derechos reservados
      </p>
    </footer>;
}